
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLink } from '@ds/components/Link'
import { IconQuality } from '@ds/icons/IconQuality'

import translations from './GradeDescription.translations'

export default {
  components: {
    RevInfoBlock,
    RevLink,
  },
  props: {
    details: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showAllText: false,
    }
  },
  computed: {
    translations: () => translations,
    IconQuality: () => IconQuality,

    tooltipModifiers() {
      return [
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top'],
          },
        },
      ]
    },
  },
  methods: {
    shouldDisplayInfoBlock(index) {
      return index === this.details.length - 1
    },
    handleReadMore() {
      this.showAllText = true
    },
  },
}
